import { getConciliationIdFromUrl } from "@/pages/conciliation/stores/utils/getConciliationId";
import { RootState } from "@/store";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useMemo } from "react";
import { useSelector } from "react-redux";

export interface StatusConciliationState {
  [conciliationId: string]: boolean;
}

const initialState: StatusConciliationState = {};

const statusConciliationSlice = createSlice({
  name: "statusConciliation",
  initialState,
  reducers: {
    setConciliationStatus: (
      state,
      action: PayloadAction<{ id: string; isClosed: boolean }>
    ) => {
      state[action.payload.id] = action.payload.isClosed;
    },
    resetConciliationStatus: () => {
      return {};
    },
  },
});

export const useCurrentConciliation = () => {
  const urlId = useMemo(
    () => getConciliationIdFromUrl(window.location.href),
    []
  );
  const isClosed = useSelector((state: RootState) =>
    urlId && state.statusConciliation[urlId] !== undefined
      ? state.statusConciliation[urlId]
      : false
  );
  return useMemo(() => ({ id: urlId, isClosed }), [urlId, isClosed]);
};

export const {
  setConciliationStatus,
  resetConciliationStatus,
} = statusConciliationSlice.actions;

export default statusConciliationSlice.reducer;
